import { useEffect, useState } from 'react';
import { useSubscriptionsAndAllowedFeaturesContext } from 'contexts/SubscriptionsAndAllowedFeaturesContext/SubscriptionsAndAllowedFeaturesContext';
import { attemptedActionStore } from '../../helpers/attemptedActionStore';
import useHandleAttemptedAction from './hooks';

/*
 * There are numerous actions throughout the app that unauthenticated users
 * (guests) are allowed to attempt, but which will not be completed until they
 * have signed up or authenticated.
 *
 * When a guest attempts a gated action (add to favorites, add to collection, etc.)
 * that action is saved in session storage and then retrieved upon returning to the page
 * so it can be continued.
 */
export function usePostAuthenticationActionController({
    isAuthenticated,
    isAuthenticationLoading,
}: {
    isAuthenticated: boolean;
    isAuthenticationLoading: boolean;
}) {
    const [didRun, setDidRun] = useState(false);
    const {
        upsellingAllowed,
        hasFetched: hasFetchedSubscriptionAndAllowedFeatures,
    } = useSubscriptionsAndAllowedFeaturesContext();
    const handleAttemptedAction = useHandleAttemptedAction();

    useEffect(() => {
        // Wait for Authentication, Feature Flags and Allowed Features to resolve before performing
        // the stashed action
        if (
            !didRun &&
            !isAuthenticationLoading &&
            hasFetchedSubscriptionAndAllowedFeatures
        ) {
            const attemptedAction = attemptedActionStore.get();

            setDidRun(true);

            if (attemptedAction && isAuthenticated) {
                attemptedActionStore.remove();
                handleAttemptedAction(attemptedAction, upsellingAllowed);
            }
        }
    }, [
        handleAttemptedAction,
        didRun,
        isAuthenticated,
        isAuthenticationLoading,
        upsellingAllowed,
        hasFetchedSubscriptionAndAllowedFeatures,
    ]);
}
